var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstCommit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "first-commit",
    clipPath: "url(#clip0_1669_13835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.87,
    d: "M16 0C24.84 0 32 7.16 32 16C32 24.84 24.84 32 16 32C7.16 32 0 24.84 0 16C0 7.16 7.16 0 16 0Z",
    fill: "#E5D4F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.63982 27.5C8.21982 27.5 7.06982 26.34 7.06982 24.92V6.25C7.06982 5.29 7.84982 4.5 8.81982 4.5H23.0998C24.0598 4.5 24.8498 5.28 24.8498 6.25V10.93H27.3198C28.3498 10.93 29.1798 11.77 29.1798 12.79V15.33C29.1798 16.36 28.3398 17.19 27.3198 17.19H24.8498V17.69H27.3198C28.3498 17.69 29.1798 18.53 29.1798 19.55V22.09C29.1798 23.12 28.3398 23.95 27.3198 23.95H24.8498V24.9C24.8498 26.32 23.6998 27.48 22.2798 27.48H9.64982L9.63982 27.5Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.6399 26.67C8.6799 26.67 7.8999 25.88 7.8999 24.92V7.07996C7.8999 6.10996 8.6799 5.32996 9.6399 5.32996H22.2699C23.2299 5.32996 24.0099 6.11996 24.0099 7.07996V24.92C24.0099 25.89 23.2199 26.67 22.2699 26.67H9.6399Z",
    fill: "#EBF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.27 5.75003C23 5.75003 23.59 6.34003 23.59 7.08003V24.92C23.59 25.66 23 26.25 22.27 26.25H9.63998C8.90998 26.25 8.31998 25.66 8.31998 24.92V7.08003C8.31998 6.34003 8.90998 5.75003 9.63998 5.75003H22.27ZM22.27 4.92003H9.63998C8.44998 4.92003 7.47998 5.89003 7.47998 7.09003V24.93C7.47998 26.13 8.44998 27.1 9.63998 27.1H22.27C23.46 27.1 24.43 26.13 24.43 24.93V7.08003C24.43 5.88003 23.46 4.91003 22.27 4.91003V4.92003Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.8999 8.61997V6.24997C7.8999 5.73997 8.3099 5.33997 8.8099 5.33997H23.0999C23.6099 5.33997 24.0099 5.74997 24.0099 6.24997V8.61997H7.8999Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.1002 5.75004C23.3802 5.75004 23.6002 5.97004 23.6002 6.25004V8.20004H8.32023V6.25004C8.32023 5.97004 8.54023 5.75004 8.82023 5.75004H23.1102M23.1102 4.92004H8.82023C8.08023 4.92004 7.49023 5.51004 7.49023 6.25004V9.03004H24.4402V6.25004C24.4402 5.51004 23.8502 4.92004 23.1102 4.92004Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.89004 7.33C10.09 7.33 10.24 7.17 10.24 6.98C10.24 6.79 10.08 6.63 9.89004 6.63C9.70004 6.63 9.54004 6.79 9.54004 6.98C9.54004 7.17 9.70004 7.33 9.89004 7.33Z",
    fill: "#FF0059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.9599 7.33C11.1599 7.33 11.3099 7.17 11.3099 6.98C11.3099 6.79 11.1499 6.63 10.9599 6.63C10.7699 6.63 10.6099 6.79 10.6099 6.98C10.6099 7.17 10.7699 7.33 10.9599 7.33Z",
    fill: "#F9CD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.02 10.95H9.92004C9.71004 10.95 9.54004 11.12 9.54004 11.33C9.54004 11.54 9.71004 11.71 9.92004 11.71H12.02C12.23 11.71 12.4 11.54 12.4 11.33C12.4 11.12 12.23 10.95 12.02 10.95Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.84 12.75H9.92004C9.71004 12.75 9.54004 12.92 9.54004 13.13C9.54004 13.34 9.71004 13.51 9.92004 13.51H10.84C11.05 13.51 11.22 13.34 11.22 13.13C11.22 12.92 11.05 12.75 10.84 12.75Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.0198 14.54H9.90979C9.69979 14.54 9.52979 14.71 9.52979 14.92C9.52979 15.13 9.69979 15.3 9.90979 15.3H13.0198C13.2298 15.3 13.3998 15.13 13.3998 14.92C13.3998 14.71 13.2298 14.54 13.0198 14.54Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.8598 16.33H9.90979C9.69979 16.33 9.52979 16.5 9.52979 16.71C9.52979 16.92 9.69979 17.09 9.90979 17.09H11.8598C12.0698 17.09 12.2398 16.92 12.2398 16.71C12.2398 16.5 12.0698 16.33 11.8598 16.33Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.02 18.13H9.92004C9.71004 18.13 9.54004 18.3 9.54004 18.51C9.54004 18.72 9.71004 18.89 9.92004 18.89H12.02C12.23 18.89 12.4 18.72 12.4 18.51C12.4 18.3 12.23 18.13 12.02 18.13Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.84 19.92H9.92004C9.71004 19.92 9.54004 20.09 9.54004 20.3C9.54004 20.51 9.71004 20.68 9.92004 20.68H10.84C11.05 20.68 11.22 20.51 11.22 20.3C11.22 20.09 11.05 19.92 10.84 19.92Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.0198 21.72H9.90979C9.69979 21.72 9.52979 21.89 9.52979 22.1C9.52979 22.31 9.69979 22.48 9.90979 22.48H13.0198C13.2298 22.48 13.3998 22.31 13.3998 22.1C13.3998 21.89 13.2298 21.72 13.0198 21.72Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.8598 23.51H9.90979C9.69979 23.51 9.52979 23.68 9.52979 23.89C9.52979 24.1 9.69979 24.27 9.90979 24.27H11.8598C12.0698 24.27 12.2398 24.1 12.2398 23.89C12.2398 23.68 12.0698 23.51 11.8598 23.51Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.0399 7.33C12.2399 7.33 12.3899 7.17 12.3899 6.98C12.3899 6.79 12.2299 6.63 12.0399 6.63C11.8499 6.63 11.6899 6.79 11.6899 6.98C11.6899 7.17 11.8499 7.33 12.0399 7.33Z",
    fill: "#00BD4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M27.31 11.77H13.27C12.7 11.77 12.23 12.23 12.23 12.81V15.35C12.23 15.92 12.69 16.39 13.27 16.39H27.31C27.88 16.39 28.35 15.93 28.35 15.35V12.81C28.35 12.24 27.89 11.77 27.31 11.77Z",
    fill: "#8ECBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.3101 12.18C27.6601 12.18 27.9301 12.46 27.9301 12.8V15.34C27.9301 15.69 27.6501 15.96 27.3101 15.96H13.2601C12.9101 15.96 12.6401 15.68 12.6401 15.34V12.8C12.6401 12.45 12.9201 12.18 13.2601 12.18H27.3101ZM27.3101 11.35H13.2601C12.4601 11.35 11.8101 12 11.8101 12.8V15.34C11.8101 16.14 12.4601 16.79 13.2601 16.79H27.3101C28.1101 16.79 28.7601 16.14 28.7601 15.34V12.8C28.7601 12 28.1101 11.35 27.3101 11.35Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M27.31 18.53H13.27C12.7 18.53 12.23 18.99 12.23 19.57V22.11C12.23 22.68 12.69 23.15 13.27 23.15H27.31C27.88 23.15 28.35 22.69 28.35 22.11V19.57C28.35 19 27.89 18.53 27.31 18.53Z",
    fill: "#F9D18B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M27.3101 18.95C27.6601 18.95 27.9301 19.23 27.9301 19.57V22.11C27.9301 22.46 27.6501 22.73 27.3101 22.73H13.2601C12.9101 22.73 12.6401 22.45 12.6401 22.11V19.57C12.6401 19.22 12.9201 18.95 13.2601 18.95H27.3101ZM27.3101 18.12H13.2601C12.4601 18.12 11.8101 18.77 11.8101 19.57V22.11C11.8101 22.91 12.4601 23.56 13.2601 23.56H27.3101C28.1101 23.56 28.7601 22.91 28.7601 22.11V19.57C28.7601 18.77 28.1101 18.12 27.3101 18.12Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.4,
    d: "M26.92 13.74H25.89C25.78 13.74 25.7 13.7 25.62 13.63C25.55 13.56 25.5 13.47 25.5 13.35V13.26C25.5 13.26 25.5 13.28 25.52 13.3C25.58 13.43 25.71 13.53 25.87 13.53H26.89C27.06 13.53 27.22 13.41 27.25 13.25C27.25 13.29 27.27 13.32 27.27 13.36C27.27 13.57 27.11 13.74 26.9 13.74H26.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M14.69 12.87H13.67C13.46 12.87 13.29 13.04 13.29 13.25C13.29 13.46 13.46 13.63 13.67 13.63H14.69C14.9 13.63 15.07 13.46 15.07 13.25C15.07 13.04 14.9 12.87 14.69 12.87Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    opacity: 0.4,
    d: "M19.89 15.41H18.86C18.79 15.41 18.73 15.39 18.67 15.35C18.55 15.28 18.48 15.16 18.48 15.01C18.48 15.01 18.48 14.93 18.5 14.9C18.5 14.92 18.5 14.93 18.52 14.95C18.58 15.08 18.71 15.18 18.87 15.18H19.89C20.06 15.18 20.22 15.06 20.25 14.9C20.25 14.94 20.27 14.97 20.27 15.01C20.27 15.22 20.1 15.39 19.9 15.39L19.89 15.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M20.3299 12.87H16.5699C16.3599 12.87 16.1899 13.04 16.1899 13.25C16.1899 13.46 16.3599 13.63 16.5699 13.63H20.3299C20.5399 13.63 20.7099 13.46 20.7099 13.25C20.7099 13.04 20.5399 12.87 20.3299 12.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M25.1302 14.51H21.3702C21.1602 14.51 20.9902 14.68 20.9902 14.89C20.9902 15.1 21.1602 15.27 21.3702 15.27H25.1302C25.3402 15.27 25.5102 15.1 25.5102 14.89C25.5102 14.68 25.3402 14.51 25.1302 14.51Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.4,
    d: "M14.7 15.41H13.67C13.46 15.41 13.29 15.24 13.29 15.03C13.29 14.99 13.29 14.96 13.31 14.92C13.31 14.94 13.31 14.95 13.33 14.97C13.39 15.1 13.52 15.2 13.68 15.2H14.7C14.87 15.2 15.03 15.08 15.06 14.92C15.06 14.96 15.08 14.99 15.08 15.03C15.08 15.24 14.91 15.41 14.71 15.41H14.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M14.69 14.51H13.67C13.46 14.51 13.29 14.68 13.29 14.89C13.29 15.1 13.46 15.27 13.67 15.27H14.69C14.9 15.27 15.07 15.1 15.07 14.89C15.07 14.68 14.9 14.51 14.69 14.51Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M17.1998 14.51H16.1798C15.9698 14.51 15.7998 14.68 15.7998 14.89C15.7998 15.1 15.9698 15.27 16.1798 15.27H17.1998C17.4098 15.27 17.5798 15.1 17.5798 14.89C17.5798 14.68 17.4098 14.51 17.1998 14.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M19.88 14.51H18.86C18.65 14.51 18.48 14.68 18.48 14.89C18.48 15.1 18.65 15.27 18.86 15.27H19.88C20.09 15.27 20.26 15.1 20.26 14.89C20.26 14.68 20.09 14.51 19.88 14.51Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M24.2799 12.87H21.9899C21.7799 12.87 21.6099 13.04 21.6099 13.25C21.6099 13.46 21.7799 13.63 21.9899 13.63H24.2799C24.4899 13.63 24.6599 13.46 24.6599 13.25C24.6599 13.04 24.4899 12.87 24.2799 12.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M26.9098 12.87H25.8898C25.6798 12.87 25.5098 13.04 25.5098 13.25C25.5098 13.46 25.6798 13.63 25.8898 13.63H26.9098C27.1198 13.63 27.2898 13.46 27.2898 13.25C27.2898 13.04 27.1198 12.87 26.9098 12.87Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M27.2898 14.89C27.2898 14.68 27.1198 14.51 26.9098 14.51C26.6998 14.51 26.5298 14.68 26.5298 14.89C26.5298 15.1 26.6998 15.27 26.9098 15.27C27.1198 15.27 27.2898 15.1 27.2898 14.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M14.1698 21.75C14.1698 21.75 14.0698 21.73 14.0398 21.69L13.3598 21.01C13.2798 20.93 13.2798 20.81 13.3598 20.73L14.0998 19.98C14.1798 19.9 14.2998 19.9 14.3798 19.98C14.4598 20.06 14.4598 20.18 14.3798 20.26L13.7798 20.86L14.3298 21.41C14.4098 21.49 14.4098 21.61 14.3298 21.69C14.2898 21.73 14.2398 21.75 14.1998 21.75H14.1698Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M14.81 22.0999C14.81 22.0999 14.76 22.0999 14.74 22.0999C14.63 22.0599 14.59 21.9499 14.62 21.8399L15.45 19.6899C15.49 19.5799 15.6 19.5399 15.7 19.5699C15.81 19.6099 15.85 19.7199 15.82 19.8299L14.99 21.9799C14.96 22.0599 14.88 22.0999 14.81 22.0999Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M16.28 21.75C16.28 21.75 16.18 21.73 16.15 21.69C16.07 21.61 16.07 21.49 16.15 21.41L16.7 20.86L16.1 20.26C16.02 20.18 16.02 20.06 16.1 19.98C16.18 19.9 16.3 19.9 16.38 19.98L17.12 20.73C17.12 20.73 17.18 20.82 17.18 20.87C17.18 20.92 17.16 20.98 17.12 21.01L16.44 21.69C16.44 21.69 16.35 21.75 16.31 21.75H16.28Z",
    fill: "#171923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1669_13835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstCommit);
export default __webpack_public_path__ + "static/media/FirstCommit.4f5cbb596cf1cf8d5ea171d2daec5f08.svg";
export { ForwardRef as ReactComponent };